<script lang="ts">
	import { addDollarSign, getNumBackInUnits } from '$lib/util/util';
	import BigNumber from 'bignumber.js';

	import { currentMarket } from '../../store';
	import { accessibleMargin, margin } from '../store';
	import { openAdjustMarginModal } from '../userInteract';
	export let sectionExpanded: boolean = true;
	let marginLeft = 0;
	$: if ($margin && new BigNumber($margin).gt(0)) {
		marginLeft =
			1 -
			Number(getNumBackInUnits($accessibleMargin, 18, 2)) /
				Number(getNumBackInUnits($margin, 18, 2));
	} else {
		marginLeft = 0;
	}
</script>

<div class="flex w-full justify-between">
	<button
		class="text-fx-grey-400 text-xs underline cursor-pointer"
		on:click={() => openAdjustMarginModal($currentMarket?.marketIdentifier)}
	>
		Total Margin
	</button>
	<div class="text-fx-grey-300 text-xs font-medium">
		{addDollarSign(Number(getNumBackInUnits($margin, 18, 2)))}
	</div>
</div>
<div class="flex w-full justify-between" class:hidden={!sectionExpanded}>
	<div class="text-fx-grey-400 text-xs">Accessible Margin</div>
	<div class="text-fx-grey-300 text-xs font-medium">
		{addDollarSign(Number(getNumBackInUnits($accessibleMargin, 18, 2)))}
	</div>
</div>
<div class="flex w-full justify-between" class:hidden={!sectionExpanded}>
	<div class="text-fx-grey-400 text-xs">Current Margin Used</div>
	<div class="text-fx-grey-300 text-xs font-medium">
		{(100 * marginLeft).toFixed(2)}%
	</div>
</div>
